import { supabaseClient, useUser } from '@auth-v2';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetchElvaSwings } from '@data';

export const ELVA_SWINGS_PAGE_SIZE = 6;

export const getElvaSwingsKey = (pageIndex: number, nameFilter: string) =>
    ['swings', 'elva', nameFilter, pageIndex] as const;

export const useElvaSwings = (pageIndex = 0, nameFilter = '') => {
    const { data: user } = useUser();
    const userId = user?.id ?? '';

    const from = pageIndex * ELVA_SWINGS_PAGE_SIZE;
    const to = from + ELVA_SWINGS_PAGE_SIZE;

    const { data: responseData, ...rest } = useQuery({
        // Implemented according to paginated query docs.
        // See: https://tanstack.com/query/latest/docs/framework/react/guides/paginated-queries
        queryKey: getElvaSwingsKey(pageIndex, nameFilter || 'all'),
        queryFn: () => fetchElvaSwings(supabaseClient, { userId, from, to, nameFilter }),
        placeholderData: keepPreviousData,
        enabled: !!userId,
    });

    const { data, count } = responseData || {};
    return { ...rest, data, count: count || 0 };
};
